export default function MasLogo({ tone = "dark", size = "md", className = "" }) {
  // tone: "dark"/"brand" -> black logo (for light bg) | "light" -> white logo (for dark bg)
  const heights = { sm: "h-7", md: "h-10", lg: "h-16", xl: "h-20" };
  const h = heights[size] || heights.md;
  const src = tone === "light" ? "/mas-logo-white.png" : "/mas-logo-black.png";
  return (
    <img src={src} alt="MAS Grading" className={`${h} w-auto select-none ${className}`} draggable={false} />
  );
}
